import React from 'react'
import {LogoLarge} from "../components/logo";
import {Col, Divider, Input, Modal, Row, Space} from "antd";
import AppButton from "../components/button";
import {HOME_PAGE_TEXT} from "../constants/text";
import StatItem from "../components/stat_item.dart";
import AppList from "../components/list";
import LandingHeader from "../components/header";
import TabView from "../components/tabview";
import SearchOutlined from "@ant-design/icons/es/icons/SearchOutlined";
import {Link, Redirect, Route} from "react-router-dom";
import DetailPage from "./detail";
import CloseOutlined from "@ant-design/icons/es/icons/CloseOutlined";


const HomePage = ({
    ...props
})=>{


    return <div className={'background dark-blue-bg'}>
        <LandingHeader/>
        <div className={'container'}>

            <br/>
            <br/>
            <Row justify={'space-between'}>
                <Col span={16} className={'font-lg'}>
                    <br/>
                    {
                        HOME_PAGE_TEXT
                    }
                    <br/>
                    <br/>
                    <AppButton
                        to={'/projects/create'}
                        glow>
                        GET STARTED
                    </AppButton>
                </Col>
                <Col style={{display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                    <StatItem
                    heading={'234'}
                    subHeading={'Games Published'}
                    />
                    <br/>
                    <StatItem
                        heading={'5234'}
                        subHeading={'Projects in Development'}
                    />
                </Col>
            </Row>
            <br/>
            <br/>
            <AppList
            header={<><Row justify={'space-between'}>
                <Row type={'flex'}>
                    <TabView
                        onChange={(item)=>{
                            props.history?.push(item)
                        }}

                        activeItem={props.location.pathname.split('/')[2] || undefined}
                    />
                </Row>
                <Col span={6}>
                    <Input
                        placeholder={'Search Games by title'}
                        search
                        suffix={<SearchOutlined className={'white'}/>}
                    />
                </Col>

            </Row>
            <Divider className={'white30-bg'}/>
            </>
            }
            />
          </div>
    <br/>
    <br/>
    <Route exact path={'/home/projects/:id'}
           render={(props)=>{
               console.log(props)
               var status = (new URLSearchParams(props.location.search)).get('status')
               return <Modal
                   width={'100%'}
                   visible
                   footer={false}
                   closeIcon={<CloseOutlined className={'white font-xxl'}/>}
                   className={'white container'}
                   onCancel={()=>props.history.goBack()}
               ><DetailPage
                   type={status}
               /></Modal>
           }}
    />
    <Redirect path={'/home'} to={'/home/Pending'} />
    </div>
}

export default HomePage